import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class IsAuthenticatedGuard implements CanActivate {
  constructor(public authService: AuthService) {}

  public canActivate(): boolean {
    return !this.authService.isAuthenticated();
  }
}
